let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ezQBv")).then(() => parcelRequire('aD5wE'));